/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Redirect } from 'react-router-dom';
import { deauthenticate } from './actions';


import toast from '../utils/ToasterService';
import { pingURL, sendRequest } from '../services/api/apiClient';
import {t} from 'i18next'


const mapStateToProps = state => ({
  authenticated: state.authentication.authenticated,
});

const mapDispatchToProps = dispatch => ({
  deauthenticate: () => dispatch(deauthenticate()),
});

/**
 * Logout
 */
class Logout extends PureComponent {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    deauthenticate: PropTypes.func.isRequired,
    redirectTo: PropTypes.string,
  }

  static defaultProps = {
    authenticated: false,
    redirectTo: '/login',
  }

  componentDidMount() {
    this.props.deauthenticate();
    this.props.history.push(this.props.redirectTo);
  }

  checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

  render() {
    this.checkConnectionToServer()
    return (
      <Fragment />
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout));
